import './index.scss';

import '../assets-base/assets-src/js/Bootstrap/carousel';
//import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
import * as ScrollDownClass from '../assets-base/assets-src/js/Spinao/ScrollDownClass';
import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
import * as ReCaptcha from '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';


document.addEventListener("DOMContentLoaded", function() {
    Lightgallery.applyTo('#js-lightgallery', {
        selector:'.js-lightgallery-image',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    //StickyTopMenu.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');
    ScrollDownClass.run();
});
